import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_OooaccommodationListComponent from "../components/_FM_oooaccommodation/_FM_OooaccommodationListComponent";
import _FM_OooaccommodationFormComponent from "../components/_FM_oooaccommodation/_FM_OooaccommodationFormComponent";
import _FM_OooaccommodationShowComponent from "../components/_FM_oooaccommodation/_FM_OooaccommodationShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_OooaccommodationPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();

  useEffect(() => {
    document.title = t('ooo_accommodations') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/oooaccommodation')
  }, []);

  return (
    <div className="_FM_OooaccommodationPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/oooaccommodation"}/>
      <Panel>
        <_FM_OooaccommodationListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/oooaccommodation');
               }}>
        <_FM_OooaccommodationFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/oooaccommodation');
               }}>
        <_FM_OooaccommodationShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_OooaccommodationPage);
